import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getNWJsMediaExistenceAction } from '~/actions/nwjs/actions'

export function useNWJsFocus() {
  const dispatch = useDispatch()

  useEffect(() => {
    if (typeof nw !== 'undefined') {
      const win = nw.Window.get()
      const onFocus = () => {
        dispatch(getNWJsMediaExistenceAction())
      }
      // const onBlur = () => setIsFocused(false)

      win.on('focus', onFocus)
      // win.on('blur', onBlur)
      onFocus()
      return () => {
        win.removeListener('focus', onFocus)
        // win.removeListener('blur', onBlur)
      }
    }
    return undefined
  }, [ dispatch ])
}
